
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/planters",
      function () {
        return require("private-next-pages/planters/index.page.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/planters"])
      });
    }
  